import {Action} from '@ngrx/store';

export const GET_ASSIGNED_FREELANCERS = '[Freelancers] Get Assigned Freelancers';
export const GET_ASSIGNED_FREELANCERS_SUCCESS = '[Freelancers] Get Assigned Freelancers Success';
export const GET_ASSIGNED_FREELANCERS_ERROR = '[Freelancers] Get Assigned Freelancers Error';

export const GET_FREELANCER = '[Freelancers] Get Freelancer';
export const GET_FREELANCER_SUCCESS = '[Freelancers] Get Freelancer Success';
export const GET_FREELANCER_ERROR = '[Freelancers] Get Freelancer Error'

export const GET_APPROVED_FREELANCERS = '[Freelancers] Get Approved Freelancers';
export const GET_APPROVED_FREELANCERS_SUCCESS = '[Freelancers] Get Approved Freelancers Success';
export const GET_APPROVED_FREELANCERS_ERROR = '[Freelancers] Get Approved Freelancers Error';

export const UPDATE_ASSIGNED_FREELANCERS = '[Freelancers] Update Assigned Freelancers';
export const UPDATE_ASSIGNED_FREELANCERS_SUCCESS = '[Freelancers] Update Assigned Freelancers Success';
export const UPDATE_ASSIGNED_FREELANCERS_ERROR = '[Freelancers] Update Assigned Freelancers Error';


export class GetAssignedFreelancers implements Action {
  readonly type = GET_ASSIGNED_FREELANCERS;

  constructor(public payload: any) {
  }
}

export class GetAssignedFreelancersSuccess implements Action {
  readonly type = GET_ASSIGNED_FREELANCERS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAssignedFreelancersError implements Action {
  readonly type = GET_ASSIGNED_FREELANCERS_ERROR;

  constructor(public payload: any) {
  }
}

export class GetFreelancer implements Action {
  readonly type = GET_FREELANCER;

  constructor(public payload: any) {
  }
}

export class GetFreelancerSuccess implements Action {
  readonly type = GET_FREELANCER_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetFreelancerError implements Action {
  readonly type = GET_FREELANCER_ERROR;

  constructor(public payload: any) {
  }
}

export class GetApprovedFreelancers implements Action {
  readonly type = GET_APPROVED_FREELANCERS;

  constructor(public payload: any) {
  }
}

export class GetApprovedFreelancersSuccess implements Action {
  readonly type = GET_APPROVED_FREELANCERS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetApprovedFreelancersError implements Action {
  readonly type = GET_APPROVED_FREELANCERS_ERROR;

  constructor(public payload: any) {
  }
}

export class UpdateAssignedFreelancers implements Action {
  readonly type = UPDATE_ASSIGNED_FREELANCERS;

  constructor(public payload: any) {
  }
}

export class UpdateAssignedFreelancersSuccess implements Action {
  readonly type = UPDATE_ASSIGNED_FREELANCERS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class UpdateAssignedFreelancersError implements Action {
  readonly type = UPDATE_ASSIGNED_FREELANCERS_ERROR;

  constructor(public payload: any) {
  }
}

export type FreelancerAction = GetAssignedFreelancers
  | GetAssignedFreelancersSuccess
  | GetAssignedFreelancersError
  | GetFreelancer
  | GetFreelancerSuccess
  | GetFreelancerError
  | GetApprovedFreelancers
  | GetApprovedFreelancersSuccess
  | GetApprovedFreelancersError
  | UpdateAssignedFreelancers
  | UpdateAssignedFreelancersSuccess
  | UpdateAssignedFreelancersError



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/freelancers/store/actions/freelancer.action.ts